import React, { Component } from 'react';
import Success from './success';
import { Route } from 'react-router-dom';
import './contact.css';

class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            contact : []            
        };
      }
    
    componentDidMount() {
        this.getContact();
      }
    
      // Retrieves the list of items from the Express app
      getContact = () => {
        fetch('/api/contact')
        .then(res => res.json())
        .then(contact => this.setState({ contact }));

      }

    render() {
        const { contact } = this.state;
        
        return (
            <React.Fragment>
                {contact.length ? (
                    <div className="contactContainer fullWidth bgWhite relative clearBoth fullHeight" >
                        {/* Render the list of items */}
                        {contact.map((item, i) => {
                        return(
                            <React.Fragment key={i}>
                            <div className="formHold floatLeft tfStage fullHeight">
                                <div className="fullWidth contactHeader marginTopLarge">
                                <p className=" fullWidth centerT resourceTitle upperT marginBotSmall titleFont" dangerouslySetInnerHTML={{ __html : item.smallText }}></p>
                                <h1 className="fullWidth marginBotMed centerT contactHeading" dangerouslySetInnerHTML={{ __html : item.bigText }}></h1>
                                </div>
                                <div className="contactFormContainer">
                                    <form className="contactForm tfStage" action="/contact/send" id="contact-form" method="post">
                                        <input className="formItem resourceAuthor required relative" name="senderName" type="text" placeholder="FULL NAME" required></input >
                                        <input className="formItem resourceAuthor required relative" name= "senderEmail" type="email" placeholder="EMAIL" required></input>
                                        <textarea className="formItem resourceAuthor textArea required relative" name="content" type="text" placeholder="MESSAGE" required></textarea>
                                        <input className="buttonCTA formButton upperT boldT" type="submit" value='Send'></input>
                                    </form>
                                </div>
                             </div> 
                             <div className="socialHold floatLeft fullHeight bgBlack">
                                <div className="iconHold marginTopLarge">
                                    <p className="centerT resourceTitle wT marginBotMed titleFont">FOLLOW US</p>
                                    <a href="https://www.twitter.com/BlackSocialists"><div className="twitter socialButton iconCover" style={{backgroundImage: `url(../social/twitter.svg`}}></div></a>
                                    <a href="https://www.instagram.com/BlackSocialists"><div className="ig socialButton iconCover" style={{backgroundImage: `url(../social/ig.svg`}}></div></a>
                                    <a href="https://www.reddit.com/r/BlackSocialists"><div className="reddit socialButton iconCover" style={{backgroundImage: `url(../social/red.svg`}}></div></a>
                                    <a href="https://www.facebook.com/BlackSocialists"><div className="fb socialButton iconCover" style={{backgroundImage: `url(../social/fb.svg`}}></div></a>
                                    <a href="https://blacksocialists.tumblr.com/"><div className="tumblr socialButton iconCover" style={{backgroundImage: `url(../social/tumblr.svg`}}></div></a>

                                </div>
                             </div>  
                            </React.Fragment>
                        );
                        })}
                        <Route exact path='/contact/success' render={()=><Success successMessage={this.state.contact[0].resNote}/>} />

                    </div>
                    ) : (
                        <div className="fullWidth fullHeight redT blinkFast loader">
                        <div className="centeredContent">•</div>
                    </div>
                    
                    )
                }
            </React.Fragment>
        )
    }
  }
  
  export default Contact;




// WEBPACK FOOTER //
// ./src/components/contact/contact.js